import { IProductNavigation } from '@adaptiva/core/app-shell';
import { Licensing } from '@adaptiva/core/licensing'; 

const _intuneRoute: string = Licensing.PRODUCT_ROUTES.get(Licensing.Products.OneSite.INTUNE);

export const ONESITE_INTUNE_PRODUCT_NAVIGATION: IProductNavigation = {
	productName: Licensing.Products.OneSite.INTUNE,
	route: _intuneRoute,
	sidenav: {
		productName: Licensing.Products.OneSite.INTUNE,
		sections: [{
			items: [
				{
					display: 'Home',
					route: '/onesite-intune',
					icon: 'faHomeOutline',
				},
				{
					display: 'P2P Apps',
					route: _intuneRoute + '/apps',
					icon: 'faCube',
				},
				{
					display: 'Live WAN Downloads',
					route: '/live-wan-downloads/download-status',
					icon: 'faChartNetworkOutline',
					linkedRoutes: [
						'/live-wan-downloads/download-status',
						'/live-wan-downloads/paused-downloads',
						'/live-wan-downloads/priority-overrides',
						'/live-wan-downloads/transport-overrides'
					],
					children: []
				},
				{
					display: 'Content Push',
					route: '/content-push',
					icon: 'faPaperPlaneOutline',
					linkedRoutes: ['/content-push/edit/:id'],
					children: []
				},
				{
					display: 'Intune Settings',
					route: '',
					icon: 'faSlidersH',
					children: [
						{
							display: 'Cloud Content Settings',
							route: _intuneRoute + '/settings/cloud-content'
						},
						{
							display: 'Intune Configuration',
							route: _intuneRoute + '/settings/intune-configuration'
						}
					]
				}
			]
		}]
	}
};
